var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19192_8901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.42188 21C7.80953 21.8914 8.4491 22.6502 9.26203 23.1831C10.075 23.716 11.0258 23.9999 11.9979 23.9999C12.9699 23.9999 13.9208 23.716 14.7337 23.1831C15.5466 22.6502 16.1862 21.8914 16.5739 21H7.42188Z",
    fill: "#A7A7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3957 12.5497L20.6597 6.82666C20.1038 4.82501 18.8951 3.06644 17.2256 1.83016C15.5561 0.593891 13.5214 -0.0492201 11.4446 0.00294028C9.36786 0.0551007 7.36804 0.799543 5.76268 2.11807C4.15733 3.43659 3.03846 5.25362 2.58371 7.28066L1.23571 12.8177C1.05655 13.5534 1.04684 14.3203 1.20732 15.0603C1.36781 15.8004 1.69429 16.4943 2.16214 17.0897C2.62998 17.6852 3.22696 18.1666 3.90803 18.4976C4.5891 18.8287 5.33646 19.0007 6.09371 19.0007H17.6107C18.3914 19.0007 19.1613 18.8179 19.8587 18.4669C20.5561 18.1159 21.1616 17.6065 21.6267 16.9794C22.0919 16.3523 22.4037 15.6251 22.5372 14.8558C22.6707 14.0866 22.6223 13.2968 22.3957 12.5497Z",
    fill: "#A7A7A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19192_8901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.295a28a4bc3061f4f91f6158d28f11b2.svg";
export { ForwardRef as ReactComponent };